@let categories = categories$ | async;
<app-top-bar [title]="display_name" [isBack]="true"></app-top-bar>
<div class="support-department-container">
  @if (categories) {
    <div class="departments-block">
      @for (item of categories | filterBy: ['enabled'] : true; track $index) {
        <div class="department-item block-background" (click)="openStandardSolution(item)">
          <div class="department-item-text main-text-color">{{ item.display_name }}</div>
          <mat-icon class="accent-color">chevron_right</mat-icon>
        </div>
      }
    </div>
  } @else {
    <app-progress-spinner [spinnerText]="'Завантаження категорій'"></app-progress-spinner>
  }
</div>
